import React from "react"
import { graphql } from "gatsby"
import { Landing } from "../styles/Contact"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { ContentWrapper } from "../styles/Wrapper"
import { useLanguage } from "../context/LanguageContext"
import { phoneIco, emailIco, printIco, houseIco } from "../utils/imageUpload"
import Observer from "@researchgate/react-intersection-observer"
import { useNav } from "../context"
import { useSpecialPage } from "../hooks/useSpecialPage.hook"
import Map from "../components/ContactPage/Map"

const Career = ({ data }) => {
  const { checkIntersection } = useNav()
  useSpecialPage(false)

  const [main] = data.allSanityContactpage.edges.map(({ node }) => node)
  const { language } = useLanguage()

  function chooseText(path, mainObj = main, lang = language) {
    return mainObj[`${path}_${lang}`]
  }

  return (
    <Layout>
      <SEO title={chooseText("sectionTitleCareer", main, language)} />
      <Landing style={{ paddingTop: "var(--navHeight)" }}>
  

        <ContentWrapper>
          <div className="main-container">
            <div
              className="box"
              data-sal="fade"
              data-sal-duration="600"
              data-sal-delay="100"
              data-sal-easing="ease"
            >
              <Observer
                rootMargin="-100px 0% -25%"
                onChange={checkIntersection}
              >
                <p className="sections title">
                  {chooseText("sectionTitleCareer")}
                </p>
              </Observer>

              <h2 style={{ marginBottom: "10px" }} className="headline">
                {chooseText("headlineCareer")}
              </h2>
              <h5 className="headline">{chooseText("subHeadlineCareer")}</h5>
              <div className="contact-info-container">
                <div className=" body contact-info">
                  <img src={phoneIco} alt="" />
                  <p>{main.phone}</p>
                </div>
                <div className=" body contact-info">
                  <img src={printIco} alt="" />
                  <p>{main.fax}</p>
                </div>
                <div className=" body contact-info">
                  <img src={emailIco} alt="" />
                  <p>{main.email}</p>
                </div>
                <div className=" body contact-info">
                  <img src={houseIco} alt="" />
                  <p>{main.address}</p>
                </div>
              </div>
            </div>
          </div>
        </ContentWrapper>  
        <a className="connect-map" href="https://wtw.onepage.me/#map" target="_blank" rel="noopener noreferrer">
          <h3 style={{ color: "var(--blue)" }}>{"↓"}</h3>
        </a>
      </Landing>
        <Map/>
    </Layout>
  )
}

export default Career

export const query = graphql`
  query {
    allSanityContactpage {
      edges {
        node {
          address
          button_de
          button_en
          company_de
          company_en
          dataProtect_de
          dataProtect_en
          email
          fax
          subHeadlineCareer_de
          subHeadlineCareer_en
          headlineCareer_de
          headlineCareer_en
          mandatory_de
          mandatory_en
          message_de
          message_en
          name_de
          name_en
          phone
          phone_de
          phone_en
          sectionTitleCareer_de
          sectionTitleCareer_en
        }
      }
    }
  }
`
